import React from "react";
import { observer } from "mobx-react-lite";

import { useTranslation } from "../../i18n/useTranslation.js";

const LoadingScreen: React.FC = observer(() => {
  const { t } = useTranslation();
  return (
    <div className="flex-center" style={{ height: "100vh", flexDirection: "column", gap: "1rem" }}>
      <p style={{ color: "#ffd700", fontSize: "1.1rem", fontFamily: "Cinzel, serif" }}>{t("common.loading")}</p>
    </div>
  );
});

export default LoadingScreen;
